import React from 'react';
import NewsWidget from '../../widgets/NewsWidget/NewsWidget';
import RecommendedOffersWidget from '../../widgets/RecommendedOffersWidget/RecommendedOffersWidget';
import NewOffersWidget from '../../widgets/NewOffersWidget/NewOffersWidget';
// import StatisticsChartWidget from '../../widgets/StatisticsChartWidget/StatisticsChartWidget';
// import SummaryWidget from '../../widgets/SummaryWidget/SummaryWidget';
// import PersonalManagerWidget from '../../widgets/PersonalManagerWidget/PersonalManagerWidget';
// import BotsWidget from '../../widgets/BotsWidget/BotsWidget';
// import StoreWidget from '../../widgets/StroreWidget/StoreWidget';
// import BannerWidget from '../../widgets/BannerWidget/BannerWidget';

export const items = {
  main: [
    {
      id: 1,
      title: 'news',
      localStorageName: 'NewsWidget',
      component: <NewsWidget key="1" />,
    },
    {
      id: 3,
      title: 'recommended-offers',
      localStorageName: 'RecommendedOffersWidget',
      component: <RecommendedOffersWidget key="3" />,
    },
    {
      id: 14,
      title: 'new-offers',
      localStorageName: 'NewOffersWidget',
      component: <NewOffersWidget key="14" />,
    },
    // {
    //   id: 2,
    //   title: 'statistics',
    //   localStorageName: 'StatisticsChartWidget',
    //   component: <StatisticsChartWidget key="2" />,
    // },
  ],
  // sidebar: [
  // {
  //   id: 12,
  //   title: 'sp-nutra',
  //   localStorageName: 'SPNutraWidget',
  //   component: <SPNutraWidget key="12" />,
  // },
  // {
  //   id: 21,
  //   title: 'sp-store',
  //   localStorageName: 'SPStoreWidget',
  //   component: <SPStoreWidget key='21' />
  // },
  // {
  //   id: 11,
  //   title: 'store',
  //   localStorageName: 'StoreWidget',
  //   component: <StoreWidget key="11" />,
  // },
  // {
  //   id: 11,
  //   title: 'manager',
  //   localStorageName: 'PersonalManagerWidget',
  //   component: <PersonalManagerWidget key="11" />,
  // },
  // {
  //   id: 15,
  //   title: 'bots-widget',
  //   component: <BotsWidget key="15" />,
  // },
  // {
  //   id: 10,
  //   title: 'summary',
  //   localStorageName: 'SummaryWidget',
  //   component: <SummaryWidget key="10" />,
  // },
  // ],
};
